/**
 * @author Radek Liška <ing.radek.liska@gmail.com>
 * @copyright Ki-Wi Digital s.r.o.
 * @license
 * All Rights Reserved.
 * Unauthorized copying of this file is strictly prohibited.
 * Proprietary and confidential.
 */

/* eslint-env browser */

import get from 'lodash/get';
import isObject from 'lodash/isObject';

import CommunicatorUtility from '../utility/communicator-utility';
import ErrorLevel from '../../error/error-level';

// TODO #94 Přidat unit testy pro nové funkcionality spojené s offline módem.
/**
 * Komunikátor push dat zařízení pro Ki-Wi Server.
 */
class CommunicatorHeartbeat {
  /**
   * Vytvoří komunikátor zařízení se serverem.
   * @returns {CommunicatorHeartbeat} Nový komunikátor push dat zařízení.
   */
  constructor() {
    this.fetching = false;
  }

  /**
   * Informuje server o online stavu a zároveň doručí push data pro zařízení.
   * @param {string} deviceId Identifikátor Ki-Wi zařízení, které chce komunikovat.
   * @param {string} serverUrl URL adresa Ki-Wi Server pro komunikaci.
   * @returns {Promise.<HeartbeatInfo|null>} Push data, pokud se je podařilo doručit.
   */
  fetch(deviceId, serverUrl) {
    // TODO #94 Omezení paralelního fetch:
    // - Zvážit umístění této funkcionality.
    // - Napsat unit testy:
    //   - Využít zpoždění fetch. https://github.com/wheresrhys/fetch-mock/issues/75
    //   - Duplikátní fetch vrací null.
    //   - Nezablokuje se při resolve.
    //   - Nezablokuje se při reject.
    let result;
    if (this.fetching) {
      // TODO Mohlo by reagovat jinak. Např. vrácením probíhajícího poždavku.
      result = Promise.resolve(null);
    } else {
      this.fetching = true;
      result = fetch(`${serverUrl}/api/device/${deviceId}/heartbeat`, {
        method: 'POST'
      })
        // Snížení priority logování pro chyby síťového spojení.
        .catch((error) => {
          error.level = ErrorLevel.Warning;
          throw error;
        })
        .then((response) => {
          // Snížení priority logování pro chyby ze serveru.
          if (!response.ok) {
            const error = new RangeError(
              `Invalid HTTP status "${response.status}".`
            );
            error.level = ErrorLevel.Warning;
            throw error;
          }
          return response.json();
        })
        .then((json) => CommunicatorHeartbeat.parse(json))
        .finally(() => {
          this.fetching = false;
        });
    }
    return result;
  }

  /**
   * Zpracuje push data zařízení.
   * @param {Object} [json] Odpověď na push data zařízení.
   * @returns {Object} Push data.
   */
  static parse(json) {
    return {
      contentTimestamp: CommunicatorUtility.parseDate(
        get(json, 'contentTimestamp')
      ),
      queueIdArray: CommunicatorHeartbeat.parseQueue(get(json, 'queues')),
      version: CommunicatorUtility.parseString(get(json, 'appVersion'), {
        nil: null
      })
    };
  }

  /**
   * Zpracuje seznam front.
   * @param {Object} [value] Identifikátory front ve formátu, který vrací server.
   * @returns {Array} Seznam identifikátorů front příkazů.
   */
  static parseQueue(value) {
    let result;
    if (isObject(value)) {
      result = Object.keys(value);
    } else {
      result = [];
    }
    return result;
  }
}

export default CommunicatorHeartbeat;
